import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useTranslation } from "react-i18next";
import { changeForm } from "../searchFlightsSlice";

function RoundTripInput() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const roundTrip = useAppSelector(
    (state) => state.searchFlights.form.roundTrip
  );

  const onChange = () => dispatch(changeForm({ roundTrip: !roundTrip }));

  return (
    <div className="field is-horizontal">
      <div className="field-label"></div>
      <div className="field-body">
        <div className="field">
          <div className="control">
            <label className="radio trip-type-radio round-trip-radio">
              <input
                type="radio"
                name="roundTrip"
                checked={roundTrip === true}
                onChange={onChange}
              />
              <span> {t("ROUND_TRIP")}</span>
            </label>
            <label className="radio trip-type-radio one-way-radio">
              <input
                type="radio"
                name="roundTrip"
                checked={roundTrip === false}
                onChange={onChange}
              />
              <span> {t("ONE_WAY")}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RoundTripInput;
